import { KeyboardEvent } from 'react';

export const onActivateKeyDown =
  (action: () => void) =>
  (event: KeyboardEvent): void => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      action();
    }
  };
